import { close } from '#utilities/js/lightboxes/menus/dropdown.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import remove from '@mailobj-browser/front/js/tree/remove.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import * as utilities from '#utilities/js/styles.js'
import * as generics from '../styles.js'
import { elements } from './styles.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const { ownerDocument } = button
    const dropdown = one(`.${generics.elements.dropdown}`, ownerDocument)
    const dropdownOpener = one(`.${utilities.modifiers.lightbox.dropdown}.${utilities.modifiers.lightbox.open}`, ownerDocument)
    const item = closest(`.${elements.item}`, dropdownOpener)
    const buttonDelete = one(`.${generics.elements.chip_delete}`, item)

    if (dropdown) {
      close()
    }

    buttonDelete.click()
  }
})

export default button => {
  onClick.listen(button)
}
